"use client";

import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "routes/trpc/root";

export const offstreetClient = createTRPCReact<AppRouter>();
